import Link from 'next/link'
import { useRouter } from 'next/router'
import classnames from 'classnames'
import styles from './filters.module.scss'
import { Categories } from '@types'

interface FiltersProps {
  categories: Categories[]
  activeCategory?: Categories
}

export const Filters = ({ categories, activeCategory }: FiltersProps) => {
  const router = useRouter()
  return (
    <div className={styles.filters}>
      <Link legacyBehavior href="/portfolio">
        <a
          className={classnames(
            router.pathname === '/portfolio'
              ? styles.isActive
              : styles.isNotActive
          )}
          href="/portfolio"
        >
          all
        </a>
      </Link>
      {categories.map((category, i) => (
        <Link legacyBehavior key={i} href={`/category/${category}`}>
          <a
            className={classnames(
              activeCategory === category ? styles.isActive : styles.isNotActive
            )}
            href={`/category/${category}`}
          >
            {category}
          </a>
        </Link>
      ))}
    </div>
  )
}
